"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeApp = exports.toccata = exports.payments = exports.functions = exports.firestore = void 0;
/**
 * # Shoutout Interface
 *
 * Stuff and stuff
 * @module
 */
const app_1 = require("./app");
const firestore = __importStar(require("./firestore"));
exports.firestore = firestore;
const functions_1 = require("./functions");
Object.defineProperty(exports, "functions", { enumerable: true, get: function () { return functions_1.functions; } });
const payments_1 = require("./payments");
Object.defineProperty(exports, "payments", { enumerable: true, get: function () { return payments_1.payments; } });
const toccata = __importStar(require("@musicaudienceexchange/toccata"));
exports.toccata = toccata;
const initializeApp = (options) => app_1.app.init(options);
exports.initializeApp = initializeApp;
//# sourceMappingURL=index.js.map